import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { TypeOverrideService } from '../../services/type-override.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';

@Component({
  selector: 'app-admin-type-overrride',
  templateUrl: './admin-type-overrride.component.html'
})
export class AdminTypeOverrrideComponent implements OnInit {

  loadingPage = true;
  addTrainingDialogRef: BsModalRef;
  filterData: any[] = [];

  newTraining: any = {
    type: '',
    value: ''
  };

  constructor(
    private modalService: BsModalService,
    private typeOverrideService: TypeOverrideService,
    private globalMessageService: GlobalMessageService,
    private cacheService: CacheService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  initView() {
    this.refreshData();
  }

  addTraining(dialog) {
    this.addTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveTraining() {
    this.addTrainingDialogRef.hide();
    this.typeOverrideService.newTraining(this.newTraining.type, this.newTraining.value)
    .subscribe(
      (result: any) => {
        this.globalMessageService.message('Training added');
        this.newTraining = {
          type: '',
          value: ''
        };
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
      }
    );
  }

  deleteTraining(training) {
    this.typeOverrideService.deleteTraining(training._id).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training deleted');
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }

  private refreshData() {
    this.loadingPage = true;
    this.typeOverrideService.getTraining().subscribe(
      (result: any) => {
        this.filterData = result;
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-type-overrride/admin-type-overrride.component.ts